//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import moment from 'moment'
import { mapState } from 'vuex'
import { Indicator, Toast } from 'mint-ui';
import CustomerList from '../components/CustomerList.vue'
export default {
  name: 'Chat',
  data() {
    return {
      src: '',
      packageMap: {
        experience: '體驗',
        halfyear: '半年',
        oneyear: '壹年',
        fiveyear: '五年'
      },
      localData: '',
      session: {},
      sessionId: '',
      text: '',
      url: '',
      logs: [],
      users: {},
      dialogShow: false,
      chatTimer: null,
      enabled: false,
      enabledType: 'doctor',
      list: []
    }
  },
  components: {
    CustomerList
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted() {
    if (this.$route.query.sessionId) {
      this.getSessionById()
    } else {
      this.getSessionByFrom()
    }
  },
  destroyed() {
    clearTimeout(this.chatTimer)
  },

  methods: {
    getDate (createdAt) {
      if (!createdAt) return ''
      return moment(createdAt).format('YYYY年MM月DD日')
    },
    close () {
      this.enabled = !this.enabled
    },
    closeSession () {
      this.$store.httpDispatch({})('closeSession', {
        sessionId: this.sessionId
      }).then((res) => {
        const { code, data, msg } = res.data
        console.log(res.data)
        if (code === 0) {
          window.alert('本次咨詢已結束')
          this.enabled = false
        } else {
          window.alert(msg)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    openDialog (type) {
      this.enabled = true
      this.dialogShow = false
      this.enabledType = type
      this.getUsers(type)
    },
    getUsers (type) {
      if (type === 'doctor') {
        this.getDoctors()
      } else if (type === 'customer') {
        this.getCustomers()
      }
    },
    getCustomers () {
      this.$store.httpDispatch({})('getCustomers')
      .then((res) => {
        if (res.data.code === 0) {
          this.list = res.data.data.users.filter((u) => u.openid !== this.user.openid)
        }
      })
    },
    getDoctors () {
      this.$store.httpDispatch({})('getDoctors')
      .then((res) => {
        if (res.data.code === 0) {
          this.list = res.data.data.users.filter((u) => u.openid !== this.user.openid)
        }
      })
    },
    // wx upload
    // wx upload image
    chooseImage () {
      const that = this
      wx.chooseImage({
        count: 1, // 默認9
        sizeType: ['original', 'compressed'], // 可以指定是原圖還是壓縮圖，默認二者都有
        sourceType: ['album', 'camera'], // 可以指定來源是相冊還是相機，默認二者都有
        success: function (res) {
          var localIds = res.localIds; // 返回選定照片的本地ID列表，localId可以作為img標簽的src屬性顯示圖片
          let image = {}
          image.url = localIds[0]
          wx.uploadImage({
            localId: localIds[0], // 圖片的localID
            isShowProgressTips: 1, // 默認為1，顯示進度提示
            success: function (res) {
              var serverId = res.serverId; // 返回圖片的服務器端ID
              that.serverId = serverId
              that.sendMessage('image')
              that.enabled = false
            }
          });
        }
      });
    },
    getSessionByFrom () {
      this.$store.httpDispatch({})('getSessionByFrom')
      .then((res) => {
        const { code, data } = res.data
        if (code === 0) {
          const session = data.session
          const users = data.users
          this.users = users
          if (session) {
            this.session = session
            this.sessionId = session._id
            this.subscribeMessage()
          } else {
            this.$router.push('/session')
          }
        }
      }).catch((err) => {
        console.log(err)
        alert('獲取會話失敗，請檢查網絡後刷新')
      })
    },
    getSessionById () {
      this.$store.httpDispatch({})('getSessionById', {
        sessionId: this.$route.query.sessionId || this.sessionId
      })
      .then((res) => {
        const { code, data } = res.data
        if (code === 0) {
          const session = data.session
          const users = data.users
          if (session) {
            this.session = session
            this.sessionId = session._id
            this.users = users
          }
        }
        this.subscribeMessage()
      }).catch((err) => {
        console.log(err)
        alert('獲取會話失敗，請檢查網絡後刷新')
      })
    },
    subscribeMessage () {
      const query = this.$route.query
      if(this.$route.path !== '/chat') {
        return false
      }
      this.$store.httpDispatch({})('getMessage', {
        sessionId: this.sessionId
      })
      .then((res) => {
        const { code, data } = res.data
        if (code === 0) {
          this.logs = data.messages
          this.logs.forEach((log) => {
            if (log.type === 'alert' && log.state === 'created' && log.from !== this.user.openid) {
              window.alert(log.text)
            }
          })
          if (this.logs.length === 0 && this.user.type === 'normal') {
            this.sendMessage('info',
              `用戶名：${this.user.nickname}, 手機號：${this.user.mobile || ''}, 套餐：${this.packageMap[this.user.package] || ''}, 開始時間：${this.getDate(this.user.startDate)}, 結束時間：${this.getDate(this.user.endDate)}`)
          }
        }
        this.chatTimer = setTimeout(() => {
          this.subscribeMessage()
        }, 2000)
      }).catch((err) => {
        console.log(err)
        const { code, msg } = err.data
        if (code === 400111) {
          return alert('此會話已被轉接，請退出聊天')
        } else {
          this.chatTimer = setTimeout(() => {
            this.subscribeMessage()
          }, 2000)
        }
      })
    },
    sendMessage (type, alertMsg) {
      const query = this.$route.query
      if (type === 'text' && !this.text) {
        return
      }
      const msg = {
        text: type === 'text' ? this.text : '',
        serverId: type === 'image' ? this.serverId : '',
        type: type,
        from: this.user.openid,
        sessionId: this.sessionId,
        createdAt: new Date()
      }
      if (alertMsg) {
        msg.text = alertMsg
      }
      this.$store.httpDispatch({})('sendMessage', msg)
        .then((res) => {
          this.sessionId = res.data.data.sessionId
        })
      this.text = ''
      const logs = Object.assign({}, this.logs)
      this.logs.push(msg)
      setTimeout(() =>  window.scrollTo(0, document.body.scrollHeight), 0)
    }
  }
}
